import {useParams, type PathParam} from 'react-router-dom'
import type {BaseDataRoute, QueryRoute} from './data-router-types'
import {useQueriesConfigs} from './use-route-query'

/**
 * Using a route, return the valid params for that route, typed
 */
export function useRouteParams<DataRouterRouteObject extends BaseDataRoute>(route: QueryRoute<DataRouterRouteObject>) {
  useQueriesConfigs(route)
  return useParams<PathParam<DataRouterRouteObject['path']>>()
}
